module.exports = __webpack_public_path__ + "step3.e589f8d.png";